import { gql } from "apollo-boost"

export const GET_MONTH_EDITABLE_STATUS = gql`
  query GetMonthEditableStatusBySubmission ($submissionId: ID!){
      getMonthEditableStatusBySubmission(submissionId: $submissionId) {
          id
          month
          year
          isBlocked
      }
  }
`
